import type { HeadingProps } from "@components/ui";
import { Heading } from "@components/ui";

import { useCheckoutContext } from "../Checkout.hooks";

export default function CheckoutAddressHeading(props: HeadingProps) {
  const { dictionary } = useCheckoutContext();

  if (!dictionary.checkoutAddressHeading) {
    return null;
  }

  return (
    <Heading size={5} className="col-span-2 mb-4 text-center" {...props}>
      {dictionary.checkoutAddressHeading}
    </Heading>
  );
}
